import React from 'react'

import Script from 'dangerous-html/react'

import './hero17.css'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Import local images
import image1 from '../images/20241031_173635.jpg'
import image2 from '../images/salon.jpg'
import image3 from '../images/20250106_205643.jpg'
import image4 from '../images/terrasse1.jpg'
import image5 from '../images/terrasse3.jpg'
import image6 from '../images/IMG-20241014-WA0002.jpg'
import image7 from '../images/IMG-20241014-WA0003.jpg'
import image8 from '../images/IMG-20241102-WA0000.jpg'
import image9 from '../images/IMG-20241102-WA0002.jpg'
import image10 from '../images/cuisine2.jpeg'

const Hero17 = () => {
  const { t } = useTranslation()
  return (
    <div className="hero17-header78">
      <div className="hero17-column thq-section-padding thq-section-max-width">
        <div className="hero17-content1">
          <h1 className="hero17-text1 thq-heading-1">
            {t('hero17.heading')}
          </h1>
          <p className="hero17-text2 thq-body-large">
            {t('hero17.content')}
          </p>
        </div>
        <div className="hero17-actions">
          <Link to="/booking">
              <button className="thq-button-outline hero17-button2">
                <span className="thq-body-small">{t('common.checkAvailability')}</span>
              </button>
          </Link>
          <Link to="/booking">
            <button className="thq-button-filled hero17-button1">
              <span className="thq-body-small">{t('common.bookNow')}</span>
            </button>
          </Link>
        </div>
      </div>
      <div className="hero17-content2">
        <div className="hero17-row-container1 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal">
            <img
              alt={t('hero17.alt1')}
              src={image1}
              className="hero17-placeholder-image10 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt2')}
              src={image2}
              className="hero17-placeholder-image11 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt3')}
              src={image3}
              className="hero17-placeholder-image12 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt4')}
              src={image4}
              className="hero17-placeholder-image13 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt5')}
              src={image5}
              className="hero17-placeholder-image14 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt6')}
              src={image6}
              className="hero17-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal">
            <img
              alt={t('hero17.alt7')}
              src={image7}
              className="hero17-placeholder-image16 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt8')}
              src={image8}
              className="hero17-placeholder-image17 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt9')}
              src={image9}
              className="hero17-placeholder-image18 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt10')}
              src={image10}
              className="hero17-placeholder-image19 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt1')}
              src={image1}
              className="hero17-placeholder-image20 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt2')}
              src={image2}
              className="hero17-placeholder-image21 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
        <div className="hero17-row-container2 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={t('hero17.alt3')}
              src={image3}
              className="hero17-placeholder-image22 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt4')}
              src={image4}
              className="hero17-placeholder-image23 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt5')}
              src={image5}
              className="hero17-placeholder-image24 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt6')}
              src={image6}
              className="hero17-placeholder-image25 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt7')}
              src={image7}
              className="hero17-placeholder-image26 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt8')}
              src={image8}
              className="hero17-placeholder-image27 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={t('hero17.alt9')}
              src={image9}
              className="hero17-placeholder-image28 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt10')}
              src={image10}
              className="hero17-placeholder-image29 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt1')}
              src={image1}
              className="hero17-placeholder-image30 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt2')}
              src={image2}
              className="hero17-placeholder-image31 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt3')}
              src={image3}
              className="hero17-placeholder-image32 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={t('hero17.alt4')}
              src={image4}
              className="hero17-placeholder-image33 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="hero17-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Hero17
